module.exports = __webpack_public_path__ + "img/sw2-b1.c1cb83a0.jpg";